(function(){
  var SEL = '.boost-sd__filter-option-content-inner';
  document.addEventListener('click', function(e){
    if (!e.target.closest || !e.target.closest(SEL)) return;
    var before = [].map.call(document.querySelectorAll(SEL), function(l){ return l.scrollTop; });
    var y = window.scrollY;
    var desktop = window.matchMedia('(min-width: 768px)').matches;
    var start = Date.now();
    var timer = setInterval(function(){
      var lists = document.querySelectorAll(SEL);
      if (lists.length === before.length) {
        lists.forEach(function(l, i){
          if (before[i] > 0 && l.scrollTop === 0) l.scrollTop = before[i];
        });
      }
      if (desktop && y > 0 && window.scrollY < y - 100) window.scrollTo(0, y);
      if (Date.now() - start > 3000) clearInterval(timer);
    }, 50);
  }, true);
})();